import { generateTableModule } from 'admin/modules/generateModule'
import { serviceGetAllEmployees } from 'admin/services/bluetrace'
import Moment from 'moment'

import { eventTimezoneSelector } from 'admin/modules/events'


const EmployeeListModule = generateTableModule({
  initialSort: {
    id: 'score',
    order: 1,
  },
  module: {
    initialData: [],
    initialState: {
      columnsVisibility: {
        avgScoreCurrent: true,
        avgScorePrev: true,
        lastName: true,
        icon: true,
        chevron: true,
      },
      pagination: {
        per_page: 5,
      },
    },
    moduleKey: 'cpo/bluetrace/employeeContagion',
    reducerKey: 'admin.bluetrace.employeeContagion.employeeList',
    refreshTime: 10000,
    services: {
      get: { service: serviceGetAllEmployees },
    },
  },
  needsDataRefreshOnQueryChanges: true,
})


// //////////////////////////////////////////////////////////////////////////////////////
// Selectors
// //////////////////////////////////////////////////////////////////////////////////////


// //////////////////////////////////////////////////////////////////////////////////////
// Actions
// //////////////////////////////////////////////////////////////////////////////////////

EmployeeListModule.registerDataAction('get', () => (dispatch, getState) => {
  const state = getState()
  const timezone = eventTimezoneSelector(state)

  const queryParams = {
    ...EmployeeListModule.selectors.queryParams(state),
    end_date: Moment().tz(timezone).endOf('day').unix(),
    start_date: Moment().tz(timezone).startOf('day').subtract(6, 'days').unix(),
  }

  return EmployeeListModule._getService('get')(queryParams)
    .then(response => dispatch({
      type: EmployeeListModule.actionKeys.getSuccess,
      payload: {
        data: response.data,
        pagination: response.pagination,
      },
    }))
    .catch(error => {
      dispatch({ type: EmployeeListModule.actionKeys.getError })
      return Promise.reject(error)
    })
})


// //////////////////////////////////////////////////////////////////////////////////////
// Reducers
// //////////////////////////////////////////////////////////////////////////////////////


export default EmployeeListModule
